import { View } from '@react-pdf/renderer';
import type { Style } from '@react-pdf/types';
import type React from 'react';

type StackPropDiretion = 'row' | 'column';
export type StackProps = {
  children: React.ReactNode;
  direction?: StackPropDiretion;
  style?: Style;
};

export const Stack = ({
  children,
  direction = 'column',
  style: _style,
}: StackProps): React.ReactNode => {
  const getDirection = (): { flexDirection: Style['flexDirection'] } => {
    if (direction === 'row') {
      return {
        flexDirection: 'row',
      };
    }

    return {
      flexDirection: 'column',
    };
  };

  const style: Style = {
    ..._style,
    ...getDirection(),
    display: 'flex',
  };

  return <View style={style}>{children}</View>;
};
